import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * Interface for entity metadata mappings stored inside "schemas" instead of models decorated by decorators.
 */
export var EntitySchema = /*#__PURE__*/_createClass(function EntitySchema(options) {
  _classCallCheck(this, EntitySchema);
  this.options = options;
  this["@instanceof"] = Symbol.for("EntitySchema");
});